import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive } from "vue"

import {storeToRefs} from "pinia";
import {useLayoutsStore} from "@/composables/layouts";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseLayout',
  setup(__props) {

const {switchLayout} = storeToRefs(useLayoutsStore());

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_KeepAlive, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(switchLayout)), null, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    }))
  ], 1024))
}
}

})